import { WarrantyDetailsComponent } from './components/guaranties/warranty-details/warranty-details.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

import { ServicesPaymentDialogComponent } from './dialogs/services-payment-dialog/services-payment-dialog.component';
import { ExpirationDateInputComponent } from './components/generics/expiration-date-input/expiration-date-input.component';
import { SexSelectorComponent } from './components/generics/sex-selector/sex-selector.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { PropertyDetailsContentComponent } from './components/properties/property-details/property-details-content/property-details-content.component';
import { PropertyDetailsComponent } from './components/properties/property-details/property-details.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule, CanActivateHome } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { UtilsService } from './services/utils.service';
import { LoginComponent } from './components/session/login/login.component';
import { MaterialModule } from './material-module';
import { AuthService } from './services/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { NavComponent } from './nav/nav.component';
import { DataTableComponent } from './components/generics/data-table/data-table.component';
import { ImageUploaderComponent } from './components/generics/image-uploader/image-uploader.component';
import { CacheService } from './services/cache.service';
import { ReloadButtonComponent } from './components/generics/reload-button/reload-button.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { SideNavMenuComponent } from './nav/side-nav-menu/side-nav-menu.component';
import { DataPrinterComponent } from './components/generics/data-printer/data-printer.component';
import { PhoneInputComponent } from './components/generics/phone-input/phone-input.component';
import { FormsModule } from '@angular/forms';
import { CorporateHomeComponent } from './components/home/corporate-home/corporate-home.component';
import { OfficeHomeComponent } from './components/home/office-home/office-home.component';
import { BrokerHomeComponent } from './components/home/broker-home/broker-home.component';
import { OfficesComponent } from './components/offices/offices.component';
import { BrokersComponent } from './components/brokers/brokers.component';
import { EditOfficeComponent } from './components/offices/edit-office/edit-office.component';
import { OfficeDetailsComponent } from './components/offices/office-details/office-details.component';
import { EditBrokerComponent } from './components/brokers/edit-broker/edit-broker.component';
import { BrokerDetailsComponent } from './components/brokers/broker-details/broker-details.component';
import { LocalitySelectorComponent } from './components/generics/locality-selector/locality-selector.component';
import { OfficeDetailsContentComponent } from './components/offices/office-details/office-details-content/office-details-content.component';
import { BrokerDetailsContentComponent } from './components/brokers/broker-details/broker-details-content/broker-details-content.component';
import { OwnersComponent } from './components/owners/owners.component';
import { EditOwnerComponent } from './components/owners/edit-owner/edit-owner.component';
import { OwnerDetailsComponent } from './components/owners/owner-details/owner-details.component';
import { OwnerDetailsContentComponent } from './components/owners/owner-details/owner-details-content/owner-details-content.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { EditPropertyComponent } from './components/properties/edit-property/edit-property.component';
import { GuarantiesComponent } from './components/guaranties/guaranties.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { NewQuoteComponent } from './components/quotes/new-quote/new-quote.component';
import { QuoteDetailsComponent } from './components/quotes/quote-details/quote-details.component';
import { QuoteResultComponent } from './components/quotes/quote-details/quote-result/quote-result.component';
import { TenantCustomFormComponent } from './components/tenants/tenant-custom-form/tenant-custom-form.component';
import { TenantCustomFormSendedComponent } from './components/tenants/tenant-custom-form/tenant-custom-form-sended/tenant-custom-form-sended.component';
import { TenantsPaymentFormComponent } from './components/tenants/tenants-payment-form/tenants-payment-form.component';
import { TenantsPaymentFormSendedComponent } from './components/tenants/tenants-payment-form/tenants-payment-form-sended/tenants-payment-form-sended.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportDetailsComponent } from './components/reports/report-details/report-details.component';
import { TableFilterComponent } from './components/generics/table-filter/table-filter.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ServicesComponent } from './components/services/services.component';
import { EditServiceComponent } from './components/services/edit-service/edit-service.component';
import { ServiceDetailsComponent } from './components/services/service-details/service-details.component';
import { ServiceDetailsContentComponent } from './components/services/service-details/service-details-content/service-details-content.component';
import { BulkCreatorComponent } from './components/generics/bulk-creator/bulk-creator.component';
import { AuthorizationConfirmComponent } from './components/authorizations/authorization-confirm/authorization-confirm.component';
import { PasswordResetComponent } from './components/session/password-reset/password-reset.component';
import { ServicesSelectorDialogComponent } from './dialogs/services-selector-dialog/services-selector-dialog.component';
import { TenantsComponent } from './components/tenants/tenants.component';
import { TenantDetailsComponent } from './components/tenants/tenant-details/tenant-details.component';
import { PaymentFormComponent } from './components/generics/payment-form/payment-form.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationDetailsComponent } from './components/notifications/notification-details/notification-details.component';
import { DigitalSignaturesComponent } from './components/digital-signatures/digital-signatures.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { CuitInputComponent } from './components/generics/cuit-input/cuit-input.component';
import { AddressFormComponent } from './components/generics/forms/address-form/address-form.component';
import { FastQuoteDialogComponent } from './dialogs/fast-quote-dialog/fast-quote-dialog.component';
import { ServiceUpdateDialogComponent } from './dialogs/service-update-dialog/service-update-dialog.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ChangeEmailDialogComponent } from './dialogs/change-email-dialog/change-email-dialog.component';
import { PhysicalPersonFormComponent } from './components/generics/forms/physical-person-form/physical-person-form.component';
import { LegalPersonFormComponent } from './components/generics/forms/legal-person-form/legal-person-form.component';
import { RepresentativeFormComponent } from './components/generics/forms/representative-form/representative-form.component';
import { EditTenantComponent } from './components/tenants/edit-tenant/edit-tenant.component';
import { TenantDetailsContentComponent } from './components/tenants/tenant-details/tenant-details-content/tenant-details-content.component';
import { FileUploaderComponent } from './components/generics/file-uploader/file-uploader.component';
import { ExternalBrokerAccessComponent } from './components/external-broker-access/external-broker-access.component';
import { PropertySelectorDialogComponent } from './dialogs/property-selector-dialog/property-selector-dialog.component';
import { NewWarrantyComponent } from './components/guaranties/new-warranty/new-warranty.component';
import { DataPrinterV2Component } from './components/generics/data-printer-v2/data-printer-v2.component';
import { RentalAdministrationComponent } from './components/guaranties/rental-administration/rental-administration.component';
import { RequestDocumentationDialogComponent } from './dialogs/request-documentation-dialog/request-documentation-dialog.component';
import { GenerateContractDialogComponent } from './dialogs/generate-contract-dialog/generate-contract-dialog.component';
import { BrokerSelectorDialogComponent } from './dialogs/broker-selector-dialog/broker-selector-dialog.component';
import { RequotationDialogComponent } from './dialogs/requotation-dialog/requotation-dialog.component';
import { RescoringDialogComponent } from './dialogs/rescoring-dialog/rescoring-dialog.component';
import { FastWarrantiesComponent } from './components/fast-warranties/fast-warranties.component';
import { WarrantyValidationDialogComponent } from './dialogs/warranty-validation-dialog/warranty-validation-dialog.component';
import { CurrencyComponent } from './components/currencies/currency/currency.component';
import { ExchangeRateComponent } from './components/currencies/exchange-rate/exchange-rate.component';
import { NewExchangeRateDialogComponent } from './dialogs/new-exchange-rate-dialog/new-exchange-rate-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ContractsComponent } from './components/contracts/contracts.component';
import { WarrantySelectorDialogComponent } from './dialogs/warranty-selector-dialog/warranty-selector-dialog.component';
import { NewContractComponent } from './components/contracts/new-contract/new-contract-component';
import { ContractDetailsComponent } from './components/contracts/contract-details/contract-details.component';
import { ZonasComponent } from './components/calculadora/zonas/zonas.component';
import { EditZonaComponent } from './components/calculadora/zonas/edit-zona/edit-zona.component';
import { TiposDescuentoComponent } from './components/calculadora/tipos-descuento/tipos-descuento.component';
import { EditTipoDescuentoComponent } from './components/calculadora/tipos-descuento/edit-tipo-descuento/edit-tipo-descuento.component';
import { MediosPagoComponent } from './components/calculadora/medios-pago/medios-pago.component';
import { EditMedioPagoComponent } from './components/calculadora/medios-pago/edit-medio-pago/edit-medio-pago.component';
import { CoberturasComponent } from './components/calculadora/coberturas/coberturas.component';
import { EditCoberturaComponent } from './components/calculadora/coberturas/edit-cobertura/edit-cobertura.component';
import { TiposFianzaComponent } from './components/calculadora/tipos-fianza/tipos-fianza.component';
import { EditTipoFianzaComponent } from './components/calculadora/tipos-fianza/edit-tipo-fianza/edit-tipo-fianza.component';
import { ServiciosContratadosComponent } from './components/calculadora/servicios-contratados/servicios-contratados.component';
import { EditServicioContratadoComponent } from './components/calculadora/servicios-contratados/edit-servicio-contratado/edit-servicio-contratado.component';
import { ComercialesComponent } from './components/comerciales/comerciales.component';
import { EditComercialComponent } from './components/comerciales/edit-comercial/edit-comercial.component';
import { ProductoComponent } from './components/calculadora/producto/producto.component';
import { ProductoDetalleComponent } from './components/calculadora/producto/producto-detalle/producto-detalle.component';

@NgModule({
    declarations: [
        AppComponent,
        ConfirmDialogComponent,
        LoginComponent,
        NavComponent,
        DataTableComponent,
        ImageUploaderComponent,
        ReloadButtonComponent,
        SideNavMenuComponent,
        DataPrinterComponent,
        PhoneInputComponent,
        CorporateHomeComponent,
        OfficeHomeComponent,
        BrokerHomeComponent,
        OfficesComponent,
        BrokersComponent,
        EditOfficeComponent,
        OfficeDetailsComponent,
        EditBrokerComponent,
        BrokerDetailsComponent,
        LocalitySelectorComponent,
        OfficeDetailsContentComponent,
        BrokerDetailsContentComponent,
        OwnersComponent,
        EditOwnerComponent,
        OwnerDetailsComponent,
        OwnerDetailsContentComponent,
        PropertiesComponent,
        EditPropertyComponent,
        PropertyDetailsComponent,
        PropertyDetailsContentComponent,
        GuarantiesComponent,
        ContractsComponent,
        NewContractComponent,
        ContractDetailsComponent,
        QuotesComponent,
        NewQuoteComponent,
        QuoteDetailsComponent,
        QuoteResultComponent,
        SexSelectorComponent,
        TenantCustomFormComponent,
        TenantCustomFormSendedComponent,
        TenantsPaymentFormComponent,
        TenantsPaymentFormSendedComponent,
        ReportsComponent,
        ReportDetailsComponent,
        TableFilterComponent,
        ServicesComponent,
        EditServiceComponent,
        ServiceDetailsComponent,
        ServiceDetailsContentComponent,
        BulkCreatorComponent,
        AuthorizationConfirmComponent,
        WarrantyDetailsComponent,
        PasswordResetComponent,
        ServicesSelectorDialogComponent,
        WarrantySelectorDialogComponent,
        TenantsComponent,
        TenantDetailsComponent,
        PaymentFormComponent,
        ExpirationDateInputComponent,
        NotificationsComponent,
        NotificationDetailsComponent,
        DigitalSignaturesComponent,
        ServicesPaymentDialogComponent,
        CuitInputComponent,
        AddressFormComponent,
        FastQuoteDialogComponent,
        ServiceUpdateDialogComponent,
        SettingsComponent,
        ChangeEmailDialogComponent,
        PhysicalPersonFormComponent,
        LegalPersonFormComponent,
        RepresentativeFormComponent,
        EditTenantComponent,
        TenantDetailsContentComponent,
        FileUploaderComponent,
        ExternalBrokerAccessComponent,
        PropertySelectorDialogComponent,
        NewWarrantyComponent,
        DataPrinterV2Component,
        RentalAdministrationComponent,
        RequestDocumentationDialogComponent,
        GenerateContractDialogComponent,
        BrokerSelectorDialogComponent,
        RequotationDialogComponent,
        RescoringDialogComponent,
        FastWarrantiesComponent,
        WarrantyValidationDialogComponent,
        CurrencyComponent,
        ExchangeRateComponent,
        NewExchangeRateDialogComponent,
        ZonasComponent,
        EditZonaComponent,
        TiposDescuentoComponent,
        EditTipoDescuentoComponent,
        MediosPagoComponent,
        EditMedioPagoComponent,
        CoberturasComponent,
        EditCoberturaComponent,
        TiposFianzaComponent,
        EditTipoFianzaComponent,
        ServiciosContratadosComponent,
        EditServicioContratadoComponent,
        ComercialesComponent,
        EditComercialComponent,
        ProductoComponent,
        ProductoDetalleComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        RecaptchaModule,
        MaterialModule,
        FormsModule,
        HttpClientModule,
        MatFormFieldModule,
        MatInputModule,
        NgHttpLoaderModule.forRoot()
    ],
    providers: [
        UtilsService,
        AuthService,
        CacheService,
        CanActivateHome,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
        { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
